import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

function IssuedItemsModal({
  title,
  onClose,
  issuedItemsModalData,
  submitApprove,
  returnItem,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    setValue,
  } = useForm({
    defaultValues: {},
  });

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setValue("approvalDate", today);
    setValue("amount", 0);
  }, [setValue]);

  const saveData = async (formData) => {
    setIsLoading(true);
    try {
      const formWithAdditionalData = {
        ...formData,
        id: issuedItemsModalData.studentId,
        departmentName: issuedItemsModalData.departmentName,
      };

      await submitApprove(formWithAdditionalData);
    } catch (error) {
      console.error("Error processing payment:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <div className="row fs-9">
                  <div className="col-md-6">
                    <div>
                      <label className="fw-bold">Student:</label>
                      <span className="ms-1">
                        {issuedItemsModalData?.studentName || "N/A"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <h5>Issued Items</h5>
                <table className="table table-bordered custom-table m-0">
                  <thead>
                    <tr>
                      <th className="fw-bold">Sr No.</th>
                      <th className="fw-bold">Issued Item</th>
                      <th className="fw-bold">Issue Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {issuedItemsModalData?.deparmentIssueDatas?.length > 0 ? (
                      issuedItemsModalData.deparmentIssueDatas.map(
                        (item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.items}</td>
                            <td>
                              {new Date(item.issuedDate).toLocaleDateString()}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan="3">No issued items found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <form onSubmit={handleSubmit(saveData)}>
                <div className="mb-5">
                  <div className="row fs-9 g-3">
                    <div className="col-md-3">
                      <label className="fw-bold">Department</label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={true}
                        value={issuedItemsModalData.departmentName}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">Approval Date</label>
                      <input
                        {...register(`approvalDate`)}
                        type="date"
                        className="form-control"
                        disabled={true}
                      />
                      {errors.approvalDate && (
                        <small className="text-danger">
                          {errors.approvalDate.message}
                        </small>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">
                        Amount
                        <span className="text-danger fs-9">*</span>
                      </label>
                      <input
                        {...register("amount", {
                          required: "This field is required.",
                        })}
                        type="text"
                        className="form-control"
                      />
                      {errors.amount && (
                        <small className="text-danger">
                          {errors.amount.message}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="row fs-9 g-3 mt-3">
                    <div className="col-md-12">
                      <label className="fw-bold">Remarks</label>
                      <textarea
                        {...register("remarks")}
                        className="form-control"
                        rows="3"
                      />
                      {errors.remarks && (
                        <small className="text-danger">
                          {errors.remarks.message}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* <div className="row fs-9 g-3 mt-3">
                    <div className="col-md-12">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          {...register("isApproved")}
                          className="form-check-input"
                          id="isApprovedCheckbox"
                        />
                        <label
                          className="form-check-label fw-bold"
                          htmlFor="isApprovedCheckbox"
                        >
                          Is Approved
                        </label>
                      </div>
                    </div>
                  </div> */}
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default IssuedItemsModal;
